import _ from "lodash";
import * as type from "./types";
export default (state = {}, action) => {
  switch (action.type) {
    case type.FETCH_COMPANY_REQUEST_APPROVALS:
      return { ..._.mapKeys(action.payload, "Id") };

    case type.EDIT_COMPANY_REQUEST_APPROVAL:
      return { ...state, [action.payload.Id]: action.payload };

    default:
      return state;
  }
};
